import PropTypes from 'prop-types'

const propTypes = {
  list: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  content: PropTypes.object.isRequired,
  onAdd: PropTypes.func,
  onMove: PropTypes.func,
  onRemove: PropTypes.func,
  showSortOrder: PropTypes.bool,
}

export default propTypes
